<mat-form-field>
  <mat-label>{{ ("search" | i18n) || "search" | titlecase }}</mat-label>
  <input
    [disabled]="disabled"
    matInput
    autocomplete="departmentSearch"
    [ngModel]="searchValue$ | async"
    (ngModelChange)="searchValue$.next($event)"
    name="organisationFilterInput"
    data-cy="profile-department-search-input" />
</mat-form-field>
<!-- Show only selected checkbox - separate row -->
<div class="mb-3">
  <mat-checkbox
    [disabled]="disabled"
    [ngModel]="showOnlySelectedDepartmentsCheckboxState$ | async"
    (ngModelChange)="showOnlySelectedDepartmentsCheckboxState$.next($event)"
    name="showSelectedDepartmentsOnly"
    class="light-blue-checkbox"
    data-cy="profile-show-selected-departments-only-checkbox">
    {{ ("showOnlySelected" | i18n) || "Nur gewählte Abteilungen anzeigen" }}
  </mat-checkbox>
</div>

<!-- All Departments row with column headers -->
<div
  class="icons-header-row"
  *ngIf="activeColumns$ | async as activeColumns">
  <div class="icons-header-columns">
    <ng-container *ngFor="let column of activeColumns">
      <div class="icons-header-column">
        <mat-icon
          *ngIf="columnConfigurations.get(column) as config"
          class="column-icon size-20"
          [matTooltip]="
            (config.tooltipKey | i18n) || config.tooltipKey | firstUppercase
          "
          [svgIcon]="config.icon">
        </mat-icon>
      </div>
    </ng-container>
  </div>
  <div class="invisible-scrollbar"></div>
</div>
<div
  class="filter-toolbar"
  *ngIf="
    (selectAllVisible$ | async) && (activeColumns$ | async) as activeColumns
  ">
  <div class="filter-toolbar-label">
    {{ "allDepartments" | i18n }}
  </div>
  <div class="filter-toolbar-columns">
    <ng-container *ngFor="let column of activeColumns">
      <div
        class="filter-toolbar-column"
        *ngIf="
          (allDepartmentsSelection$ | async)?.get(column) as checkboxState
        ">
        <mat-checkbox
          [disabled]="disabled"
          [checked]="checkboxState === 'selected'"
          [indeterminate]="checkboxState === 'indeterminate'"
          (click)="
            $event.preventDefault();
            toggleSelectAll(column, checkboxState !== 'selected')
          "
          class="light-blue-checkbox"
          [attr.data-cy]="column + '-all-checkbox-' + checkboxState">
        </mat-checkbox>
      </div>
    </ng-container>
  </div>
  <div class="invisible-scrollbar"></div>
</div>

<!-- New reactive organization/department list -->
<div
  class="recursive-list"
  *ngIf="filteredOrganisations$ | async as organisations">
  <ul
    data-cy="organisations-list"
    *ngIf="combinedSelection$ | async as selection">
    <ng-container
      *ngFor="
        let organisation of organisations;
        trackBy: trackByOrganisationId
      ">
      <li class="parent-item">
        <div
          class="list-item-content justify-content-between"
          [attr.disabled]="disabled || null"
          [attr.data-cy]="
            'organisation-multiselect-list-item-' + organisation._id
          ">
          <div class="item-text">{{ organisation.name }}</div>
          <div
            class="checkbox-wrapper"
            *ngIf="activeColumns$ | async as activeColumns">
            <ng-container *ngFor="let column of activeColumns">
              <mat-checkbox
                *ngIf="
                  (combinedSelectionByOrganisation$ | async)
                    ?.get(organisation._id)
                    ?.get(column) as organisationSelection
                "
                class="organisation-checkbox-bg inverted-white-checkbox"
                [attr.data-cy]="
                  'organisation-' +
                  column +
                  '-' +
                  organisation._id +
                  '-' +
                  organisationSelection
                "
                [disabled]="
                  disabled ||
                  ((editableOrganisationIds$ | async) &&
                    !(editableOrganisationIds$ | async)?.has(organisation._id))
                "
                [checked]="organisationSelection === 'selected'"
                [indeterminate]="organisationSelection === 'indeterminate'"
                (click)="$event.stopPropagation()"
                (change)="
                  toggleOrganizationColumn(organisation, column, $event.checked)
                ">
              </mat-checkbox>
            </ng-container>
          </div>
        </div>
        <ul>
          <ng-container
            *ngFor="
              let department of organisation.departments;
              trackBy: trackByDepartmentId
            ">
            <!-- Department row with reactive columns -->
            <li
              class="deepest-item"
              [attr.data-cy]="
                'department-multiselect-list-item-' + department.id
              ">
              <div
                [attr.disabled]="disabled || null"
                class="list-item-content justify-content-between">
                <div class="d-flex">
                  <div class="item-text">{{ department.name }}</div>
                  <div
                    *ngIf="(blacklistedByPooler$ | async)?.has(department.id)"
                    data-cy="department-blacklisted-by-pooler-hint"
                    class="item-hint">
                    {{
                      ("disabledByPooler" | i18n) ||
                        "vom Mitarbeitenden deaktiviert"
                    }}
                  </div>
                  <div
                    *ngIf="
                      (blacklistedByDepartment$ | async)?.has(department.id)
                    "
                    data-cy="department-blacklisted-by-department-hint"
                    class="item-hint">
                    {{
                      ("blacklistedByDepartment" | i18n) ||
                        "von der Abteilung deaktiviert"
                    }}
                  </div>
                </div>

                <div
                  class="checkbox-wrapper"
                  *ngIf="activeColumns$ | async as activeColumns">
                  <ng-container *ngFor="let column of activeColumns">
                    <mat-checkbox
                      class="light-blue-checkbox"
                      [checked]="
                        selection.get(department.id)?.get(column) || false
                      "
                      [attr.data-cy]="
                        'department-' + column + '-' + department.id
                      "
                      [disabled]="
                        disabled ||
                        ((editableDepartmentIds$ | async) &&
                          !(editableDepartmentIds$ | async)?.has(department.id))
                      "
                      (click)="$event.stopPropagation()"
                      (change)="
                        toggleDepartmentSelection(
                          department.id,
                          column,
                          $event.checked
                        )
                      ">
                    </mat-checkbox>
                  </ng-container>
                </div>
              </div>
            </li>
          </ng-container>
        </ul>
      </li>
    </ng-container>
  </ul>
</div>
